module.exports = __webpack_public_path__ + "static/media/1 09 skjelven.e58c45f0.mp3";